import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from '@phosphor-icons/react';

const faqs = [
  {
    question: 'What materials are used in your jewelry?',
    answer: 'Our jewelry is crafted using high-quality materials including American Diamond gold-plated brass, cubic zirconia, and premium artificial pearls. We ensure all materials are hypoallergenic and safe for daily wear.'
  },
  {
    question: 'How do I care for my jewelry?',
    answer: 'To maintain the shine and quality of your jewelry: Store in a dry place away from moisture, avoid contact with perfumes and lotions, clean gently with a soft cloth, and remove before swimming or bathing. Proper care will help your pieces last longer.'
  },
  // {
  //   question: 'What is your return policy?',
  //   answer: 'We offer a 7-day return policy for unused items in original packaging. If you\'re not satisfied with your purchase, contact us within 7 days of delivery for a full refund or exchange. Custom orders are non-returnable.'
  // },
  {
    question: 'How long does shipping take?',
    answer: 'We offer Pan-India shipping. Standard delivery takes 5-7 business days, while express delivery takes 2-3 business days. You\'ll receive tracking information once your order is shipped.'
  },
  // {
  //   question: 'Do you offer gift packaging?',
  //   answer: 'Yes! All our jewelry comes in elegant gift-ready packaging at no extra cost. For special occasions, we also offer premium gift boxes and personalized messages.'
  // },
  {
    question: 'How can I track my order?',
    answer: 'Once your order is shipped, you\'ll receive a WhatsApp message and email with tracking details. You can also contact us on WhatsApp for real-time updates on your order status.'
  },
  // {
  //   question: 'Are your products suitable for sensitive skin?',
  //   answer: 'Yes, we use hypoallergenic materials in all our products. However, if you have specific allergies, please check the product description or contact us before purchasing.'
  // },
  // {
  //   question: 'Do you offer bulk or wholesale orders?',
  //   answer: 'Yes, we offer special pricing for bulk and wholesale orders. Contact us on WhatsApp or email with your requirements and we\'ll provide a customized quote.'
  // }
];

const FAQItem = ({ faq, isOpen, onToggle, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className="border-b border-border-default"
    >
      <button
        onClick={onToggle}
        className="w-full py-5 flex items-center justify-between text-left group"
        data-testid={`faq-toggle-${index}`}
      >
        <span className="font-display text-lg text-secondary group-hover:text-primary transition-colors pr-4">
          {faq.question}
        </span>
        <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
          isOpen ? 'bg-primary text-white' : 'bg-background-subtle text-text-secondary group-hover:bg-primary/10'
        }`}>
          {isOpen ? <Minus size={16} /> : <Plus size={16} />}
        </span>
      </button>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <p className="pb-5 font-body text-text-secondary leading-relaxed">
              {faq.answer}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const FAQSection = ({ limit, showTitle = true }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const displayFaqs = limit ? faqs.slice(0, limit) : faqs;

  return (
    <div>
      {showTitle && (
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl text-secondary mb-4">Frequently Asked Questions</h2>
          <p className="font-body text-text-secondary max-w-xl mx-auto">
            Find answers to common questions about our products and services
          </p>
        </div>
      )}
      
      <div className="max-w-3xl mx-auto">
        {displayFaqs.map((faq, index) => (
          <FAQItem
            key={index}
            faq={faq}
            index={index}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>
    </div>
  );
};

export { FAQSection, faqs };
export default FAQSection;
